export const currency = (value: number, sign = '₽', htmlSign = false) => {
    const price = Math.round(value * 100) / 100;
    let formatted = new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' }).format(price);

    formatted = `${formatted}`.replace(',00', '').replace('₽', '').trim();

    if (sign) {
        if (htmlSign) {
            formatted = `${formatted}\u00A0<span>${sign}</span>`;
        } else {
            formatted = `${formatted}\u00A0${sign}`;
        }
    }

    return formatted;
}
